define('gotomeet/setup/setup-modal',['require','knockout','durandal/app','plugins/dialog','web-urls','api-access','api-access','i18next','dialog-helper/responsive','meeting-modal/gotomeet/personalize-meeting','lib/gotomeetme/suggest-url','lib/gotomeetme/get-steps-image-url','mixpanel-helper'],function (require) {
    var ko = require('knockout');
    var app = require('durandal/app');
    var dialog = require('plugins/dialog');
    var webUrls = require('web-urls');
    var userApi = require('api-access').user;
    var gotomeetApi = require('api-access').gotomeet;
    var i18n = require('i18next');
    var responsiveDialog = require('dialog-helper/responsive');
    var personalizeMeeting = require('meeting-modal/gotomeet/personalize-meeting');
    var suggestUrl = require('lib/gotomeetme/suggest-url');
    var getStepsImageUrl = require('lib/gotomeetme/get-steps-image-url');
    var mixpanelHelper = require('mixpanel-helper');

    var SetupModal = function () {
        var self = this;

        var userInfo;

        self.stepsCreateImageUrl = ko.observable(getStepsImageUrl('setup-create'));
        self.stepsShareImageUrl = ko.observable(getStepsImageUrl('setup-share'));
        self.stepsMeetImageUrl = ko.observable(getStepsImageUrl('setup-meet'));

        self.goToMeetMeUrl = ko.observable(webUrls.get('gotoMeetMeUrl'));
        self.hasFocusUrl = ko.observable();
        self.hasUserTypedUrl = ko.observable(false);
        self.suggestedUrl = ko.observable();

        /*
         * instantUrl: tracks the input value immediately
         * delayedUrl: updates based on instantUrl at a rate limit.
         * Use delayedUrl as the accepted value, not instantUrl.
         */
        self.instantUrl = ko.observable(null);
        self.delayedUrl = ko.pureComputed(self.instantUrl).extend({
            rateLimit: {
                method: 'notifyWhenChangesStop',
                timeout: 400
            },
            required: {
                // Set a "truthy" blank message, so default error text isn't inserted.
                message: ' ',
                onlyIf: function () {
                    return self.suggestedUrl();
                }
            },
            urlRegex: true,
            takenG2mmUrl: true
        });

        /**
         * Record that the user has actively typed into the URL field.
         * Only show the URL success message if that is the case.
         */
        self.delayedUrl.subscribe(function () {
            if (self.suggestedUrl() && self.delayedUrl()) {
                if (self.suggestedUrl() !== self.delayedUrl()) {
                    self.hasUserTypedUrl(true);
                }
            }
        });

        self.reserveUrl = function () {
            var profileInfo = {
                profileId: self.delayedUrl(),
                userKey: userInfo.key,
                roomName: userInfo.firstName + '\'s Meeting',
                name: userInfo.firstName + ' ' + userInfo.lastName
            };

            gotomeetApi.create(profileInfo)
                .then(function () {
                    self.close();

                    app.trigger('get:settings');

                    var listenForOpenPersonalizeModal = function (bannerData) {
                        var element = $(bannerData.element);
                        $(element.find('.open-personalize-modal')).click(function (event) {
                            event.preventDefault();
                            personalizeMeeting.show();
                        });
                    };

                    var fullUrl = self.goToMeetMeUrl() + '/' + self.delayedUrl();

                    var modalSuccessBanner = {
                        classes: 'alert-success',
                        iconClasses: 'togo-icon togo-icon-check',
                        message: i18n.t('gotomeetme.reservation.reservationSuccess',
                            '<a href="' + fullUrl + '" target="_blank">', '</a>',
                            '<a class="open-personalize-modal" href="#">', '</a>'),
                        onAddSuccess: listenForOpenPersonalizeModal
                    };

                    app.trigger('banner:addOne', modalSuccessBanner);
                });
        };

        self.close = function () {
            dialog.close(self);
        };

        self.activate = function () {
            mixpanelHelper.track('Open G2MM Setup Modal');

            return userApi.me().then(function (res) {
                userInfo = res;
                suggestUrl(res.firstName, res.lastName)
                    .then(function (url) {
                        self.instantUrl(url);
                        self.suggestedUrl(url);
                    });
            });
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);
            self.hasFocusUrl(true);
        };
    };

    SetupModal.show = function () {
        return dialog.show(new SetupModal());
    };

    return SetupModal;
});

